module.exports = __webpack_public_path__ + "img/016.30475da9.jpg";